export default "__VITE_ASSET___0r8AfgF__"